<template>
  <div class="indexMicro indexPackage">
    <Menu mode="horizontal" active-name="1">
      <MenuItem name="1">学堂备课包</MenuItem>
    </Menu>
    <div class="lookmore" @click="viewMore('lessonPackage')">查看更多
      <Icon type="ios-arrow-forward" />
    </div>
    <div class="microcontentbox">
      <div class="microLeft">
        <img src="/static/images/indexPackage.png" alt="">
        <div class="lookmoreBtn" @click="viewMore('lessonPackage')">点击进入</div>
      </div>
      <div class="microRight">
        <div class="microClassList">
          <Row type="flex" justify="start" class="code-row-bg" v-for="(item,index) in packageList" :key="index" style="margin-bottom:15px;">
            <div class="packageCar" v-for="(n,m) in item" :key="m">
                <div class="pacageTop" @click="toPackageDetail(n.id,'lessonPackage')">
                    <div class="packageTL" :ref="'ImgBoxWidth'+ m">
                        <img :src="imgurl + n.imgPath" alt="">
                    </div>
                    <div class="packageTR">
                        <div class="packageTitle" :title="n.name">{{ n.name.split("（")[0]}}</div>
                        <div class="packageVersion packageCom">版本：{{n.versionName.length> 3 ? n.versionName.slice(0,3)+'...':n.versionName}}</div>
                        <!-- <div class="packageGrade packageCom">年级：{{n.gradeName.length > 3 ? n.gradeName.slice(0,3)+'...':n.gradeName}}</div> -->
                        <!-- <div class="packageVolume packageCom">册别：{{n.catalogName}}</div> -->
                        <!-- <div class="packageSubject packageCom">学科：{{n.subjectName.length > 3 ? n.subjectName.slice(0,3)+'...':n.subjectName}}</div> -->
                        <!-- <div class="packageVersion packageCom">版本：{{n.versionName.length> 3 ? n.versionName.slice(0,3)+'...':n.versionName}}</div> -->
                        <!-- <div class="packageType packageCom">类型：{{n.type == 0 ? "同步课" : "专题课"}}</div> -->
                    </div>
                </div>
                <!-- <div class="packageBottom">更新时间：{{n.updateTime}}</div> -->
            </div>
          </Row>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  export default {
    name: 'IndexPackage',
    data() {
      return {
        urlHttp:'/testIp',
        microList:null,                                         //微课列表  array
        imgurl:'https://qcban.aixuetang.com/res/',              //微课图片地址  线上域名
        packageList:null,
        documentHeight:'',
        websiteId:''
      }
    },
    mounted() {
      this.getLessonPackageData()
      this.websiteId = localStorage.getItem("websiteId")
    },
    updated(){
        this.documentHeight = this.$refs.ImgBoxWidth0[0].clientWidth*1/0.72+'px'
        //console.log('图片宽度',this.$refs.ImgBoxWidth0[0].clientWidth)
    },
    methods: {
      //获取备课包列表
      getLessonPackageData(){
          const that = this;
          const result = [];
          const url = '/axt-resources/package_prepare/pageCourse';
          var params = {
              name: null,
              gradeId: null,
              subjectId: null,
              catalogId: null,
              versionId: null,
              type: null,
              websiteId:this.websiteId,
              publishStatus: 1,
              startTime : null,
              endTime : null,
              pageNo: 1,
              pageSize: 50,
              status: 1,
              source: 1,
              "orderBys": [{
                    "direction": "desc",
                    "field": "update_time"
              }]

          };
         // console.log(params,"222222")
          api.postFormAPI(url,params).then(res => {
            if (res.data.success) {
                const packageList = that.getArrayItems(res.data.data.rows,8)
                for(let i = 0 ; i < 8; i++){
                  if(packageList[i].versionName == undefined) packageList[i].versionName = '';
                  if(packageList[i].gradeName == undefined) packageList[i].gradeName = '';
                  if(packageList[i].subjectName == undefined) packageList[i].subjectName = '';
                }
                for(let i=0;i < 8;i+=4){
                    result.push(packageList.slice(i,i+4));
                }
                that.packageList = result;
            }else{
                that.packageList = []
                // that.$Message.error(res.data.message);
            }
          })
      },
      getArrayItems(arr, num){
        var temp_array = new Array();
        for (var index in arr) {
            temp_array.push(arr[index]);
        }
        var return_array = new Array();
        for (var i = 0; i<num; i++) {
            if (temp_array.length>0) {
                var arrIndex = Math.floor(Math.random()*temp_array.length);
                return_array[i] = temp_array[arrIndex];
                temp_array.splice(arrIndex, 1);
            } else {
                break;
            }
        }
        return return_array;
      },
      viewMore(name) {
        this.$router.push({
          name: name
        });
        this.$emit('routerMicroName', name);
        this.$nextTick(()=>{
          $("body").scrollTop(0);
        })
      },
      //点击查看详情
      toPackageDetail(packageId,name){
        this.$router.push({ name: name });
        this.$emit('indexPackage',{'packageId':packageId,'isFromIndex':true,'routerMicroName':name});
        this.$nextTick(()=>{
          $("body").scrollTop(0);
        })
      }
    }
  }
</script>

<style>
  .indexMicro {
    position: relative;
  }
  .indexMicro .ivu-menu {
    z-index: 0;
  }

  .indexPackage .microRight {
    width: 82%;
    margin-left: 0;
  }
  .indexPackage .microLeft img {
    height: 100%;
  }
    .indexPackage .packageCar{
        width:24.25%;
        background: white;
        box-shadow: 0px 0px 15px 3px rgba(203, 209, 219, 0.62);
        border-radius: 4px;
        margin-right: 1%;
        position: relative;
        cursor: pointer;
    }
    .indexPackage .packageCar:nth-of-type(4n+4){
      margin-right: 0;
    }
    .indexPackage .packageCar:hover{
        /* margin-top:-10px; */
        /* top: -5px; */
        animation-name:ImgHoverPackage;
        animation-duration:.3s;
        animation-fill-mode: forwards;
    }
    @keyframes ImgHoverPackage{
    	from {top:0px;}
    	to {top:-5px;}
    }
    @-webkit-keyframes ImgHoverPackage /* Safari 和 Chrome */{
    	from {top:0px;}
    	to {top:-5px;}
    }
    .indexPackage .pacageTop{
        /* height:210px; */
        display:flex;
        /* padding-top: 10px; */
        flex-direction: row;
    }
    .indexPackage .packageTL{
        flex:1;
        display: table-cell;
        line-height: 1.6;
        padding: 10px 0;
    }
    .indexPackage .packageTL img{
        width:80%;
        margin: auto;
        display: inline-block;
        vertical-align: middle;
    }
    .indexPackage .packageTR{
      padding-top: 17px;
        flex:1;
        text-align: left;
        display: flex;
        flex-flow: column;
    }
    .indexPackage .packageTitle{
        font-size: 16px;
        font-weight: 500;
        color: #34495E;
        line-height: 1.6;
        height: 50px;
        margin: 6px 0 30px;
    }
    .indexPackage .packageCom{
        font-size: 14px;
        color: #999999;
        line-height: 1.6;
    }
    .indexPackage .packageBottom{
        background: #3683FF;
        font-size: 14px;
        color:#ffffff;
        text-align: center;
        line-height: 35px;
        border-radius: 0px 0px 10px 10px;
        overflow: hidden;
        white-space: nowrap;
    }
    .microClassList .code-row-bg:last-of-type {
      margin-bottom: 0!important;
    }
    @media screen and (min-width: 1440px ) {
          .indexPackage .packageCom {
            line-height: 1.6;
          }
        }
    @media screen and (min-width: 1600px ) {
      .indexPackage .packageCom {
        line-height: 2;
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/index/IndexPackage.vue